import React, { useState } from 'react';
import api from '../../utils/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Plus, Trash2 } from 'lucide-react';

export const SegnalatoriTab = ({ segnalatori, segStats, onReload }) => {
  const [segForm, setSegForm] = useState({ nome: '', cognome: '', telefono: '', email: '', note: '' });
  const [segDialogOpen, setSegDialogOpen] = useState(false);

  const handleSaveSegnalatore = async () => {
    if (!segForm.nome.trim()) { toast.error('Inserisci il nome'); return; }
    try {
      await api.post('/segnalatori', segForm);
      toast.success('Segnalatore creato');
      setSegDialogOpen(false);
      setSegForm({ nome: '', cognome: '', telefono: '', email: '', note: '' });
      onReload();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const handleDeleteSegnalatore = async (id) => {
    if (!window.confirm('Eliminare questo segnalatore?')) return;
    try {
      await api.delete(`/segnalatori/${id}`);
      onReload();
    } catch {}
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold text-slate-800">Gestione Segnalatori</h3>
        <Button size="sm" className="bg-slate-800 hover:bg-slate-700 text-white" onClick={() => setSegDialogOpen(true)} data-testid="new-segnalatore-btn">
          <Plus size={14} className="mr-1" /> Nuovo Segnalatore
        </Button>
      </div>
      {/* Segnalatori Stats */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 border-b">
            <th className="text-left px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase">Segnalatore</th>
            <th className="text-left px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Telefono</th>
            <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Pratiche</th>
            <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Erogate</th>
            <th className="text-right px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Importo</th>
            <th className="text-right px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Provvigioni</th>
            <th className="px-3 py-2.5"></th>
          </tr></thead>
          <tbody className="divide-y divide-slate-100">
            {segStats.length === 0 ? (
              <tr><td colSpan="7" className="text-center py-8 text-slate-400">Nessun segnalatore</td></tr>
            ) : segStats.map((s, i) => {
              const segData = segnalatori.find(sg => sg.id === s.id);
              return (
                <tr key={i} className="hover:bg-slate-50/50" data-testid={`seg-row-${s.id || i}`}>
                  <td className="px-4 py-2.5 font-medium text-slate-800">{s.nome}</td>
                  <td className="px-3 py-2.5 text-xs text-slate-500">{segData?.telefono || '-'}</td>
                  <td className="px-3 py-2.5 text-center font-bold text-slate-700">{s.pratiche_totali}</td>
                  <td className="px-3 py-2.5 text-center"><Badge className="bg-emerald-100 text-emerald-700 text-[10px]">{s.pratiche_erogate}</Badge></td>
                  <td className="px-3 py-2.5 text-right text-xs text-slate-600">{s.importo_totale ? `${s.importo_totale.toFixed(2)} EUR` : '-'}</td>
                  <td className="px-3 py-2.5 text-right font-bold text-emerald-700">{s.provvigioni_totali ? `${s.provvigioni_totali.toFixed(2)} EUR` : '-'}</td>
                  <td className="px-3 py-2.5">{s.id && <button onClick={() => handleDeleteSegnalatore(s.id)} className="p-1 text-slate-400 hover:text-red-500"><Trash2 size={13} /></button>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Dialog Nuovo Segnalatore */}
      <Dialog open={segDialogOpen} onOpenChange={setSegDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>Nuovo Segnalatore</DialogTitle></DialogHeader>
          <div className="space-y-3 pt-2">
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs">Nome *</Label><Input value={segForm.nome} onChange={e => setSegForm(p => ({...p, nome: e.target.value}))} className="mt-1" data-testid="seg-form-nome" /></div>
              <div><Label className="text-xs">Cognome</Label><Input value={segForm.cognome} onChange={e => setSegForm(p => ({...p, cognome: e.target.value}))} className="mt-1" /></div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs">Telefono</Label><Input value={segForm.telefono} onChange={e => setSegForm(p => ({...p, telefono: e.target.value}))} className="mt-1" /></div>
              <div><Label className="text-xs">Email</Label><Input value={segForm.email} onChange={e => setSegForm(p => ({...p, email: e.target.value}))} className="mt-1" /></div>
            </div>
            <div><Label className="text-xs">Note</Label><Textarea value={segForm.note} onChange={e => setSegForm(p => ({...p, note: e.target.value}))} rows={2} className="mt-1" /></div>
            <Button onClick={handleSaveSegnalatore} className="w-full bg-slate-800 hover:bg-slate-700 text-white" data-testid="save-segnalatore-btn">Salva</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
